import { API_ENDPOINTS, PRIVACY_API_BASE_URL } from '../constants';

const JSON_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};

function getMessageFromBody(data) {
    if (!data || typeof data !== 'object') return null;
    return (
        data.message ||
        data.error ||
        (typeof data.detail === 'string' ? data.detail : null) ||
        data.msg ||
        null
    );
}

/**
 * POST public privacy request (no auth).
 * @param {{ name: string, email: string, requestType: string, requestorType: string, notes?: string }} payload
 */
export async function submitPrivacyRequest(payload) {
    const url = `${PRIVACY_API_BASE_URL}${API_ENDPOINTS.PRIVACY.REQUEST}`;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify(payload)
        });

        let data = null;
        const text = await response.text();
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            data = null;
        }

        if (!response.ok) {
            const msg = getMessageFromBody(data) || 'Something went wrong. Please try again later.';
            return { ok: false, status: response.status, message: msg };
        }

        return { ok: true, data: data || {} };
    } catch (e) {
        console.error('submitPrivacyRequest:', e);
        return {
            ok: false,
            message:
                'We could not reach our servers. Please check your connection and try again in a few minutes.'
        };
    }
}

/**
 * POST token verification (no auth).
 * @param {{ token: string }} payload
 */
export async function verifyPrivacyRequest(payload) {
    const url = `${PRIVACY_API_BASE_URL}${API_ENDPOINTS.PRIVACY.VERIFY}`;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify(payload)
        });

        let data = null;
        const text = await response.text();
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            data = null;
        }

        if (!response.ok) {
            const msg = getMessageFromBody(data) || 'This verification link is invalid or has expired. Please submit a new request.';
            return { ok: false, status: response.status, message: msg, data: data || {} };
        }

        return { ok: true, data: data || {} };
    } catch (e) {
        console.error('verifyPrivacyRequest:', e);
        return {
            ok: false,
            message:
                'We could not reach our servers. Please check your connection and try again in a few minutes.'
        };
    }
}
